import {Checkbox} from '~/components/checkbox'
import {getMultiActionRowState} from '~/components/advanced_table/helpers'
import {useMultiActionContext} from '~/components/multi_action/context/multi_action_context'

export const CellCheckbox = ({row, cell, multiAction, getRowDisabled}) => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler

	const multiActionContext = useMultiActionContext()
	const getRowCanUseMultiAction = candidateRow => {
		if (getRowDisabled?.(candidateRow)) return false
		return multiAction.getRowIsEditable ? multiAction.getRowIsEditable(candidateRow) : true
	}

	if (cell?.hasSubRows)
		return <GroupedCellCheckbox row={row} multiActionContext={multiActionContext} getRowCanUseMultiAction={getRowCanUseMultiAction} />

	const {multiActionIds, setMultiActionActive, toggleMultiActionIds} = multiActionContext
	const rowId = row.original.id
	const disabled = !getRowCanUseMultiAction(row)
	const checked = multiActionIds.includes(rowId)
	const handleChange = () => {
		setMultiActionActive(true)
		toggleMultiActionIds(rowId)
	}

	return <Checkbox checked={checked} disabled={disabled} onChange={handleChange} onClick={e => e.stopPropagation()} />
}

const GroupedCellCheckbox = ({row, multiActionContext, getRowCanUseMultiAction}) => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler

	const {multiActionIds, setMultiActionActive, toggleMultiActionIds} = multiActionContext
	const {disabled, checked, indeterminate, editableRowIds} = getMultiActionRowState(row.subRows, getRowCanUseMultiAction, multiActionIds)

	const handleChange = () => {
		setMultiActionActive(true)
		toggleMultiActionIds(editableRowIds)
	}

	return (
		<Checkbox
			checked={indeterminate ? 'indeterminate' : checked}
			onClick={e => e.stopPropagation()}
			disabled={disabled}
			onChange={handleChange}
		/>
	)
}
